var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmailIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.0278709 10.7179C-0.402129 4.62787 4.62787 -0.402129 10.7179 0.0278709C16.0079 0.387871 19.9979 5.00787 19.9979 10.3179V11.4079C19.9979 12.8479 19.1779 14.2179 17.8379 14.7479C16.2079 15.3979 14.4279 14.7579 13.5379 13.5379C12.3879 14.7079 10.6379 15.2979 8.79787 14.8679C6.90787 14.4179 5.41787 12.8379 5.07787 10.9279C4.46787 7.50787 7.33787 4.56787 10.7379 5.05787C13.2179 5.40787 14.9979 7.66787 14.9979 10.1779V11.4279C14.9979 12.2179 15.7079 12.9979 16.4979 12.9979C17.2879 12.9979 17.9979 12.2179 17.9979 11.4279V10.3279C17.9979 6.59787 15.5779 3.17787 11.9579 2.25787C6.15787 0.757871 0.757871 6.16787 2.24787 11.9679C3.17787 15.5779 6.59787 17.9979 10.3279 17.9979H13.9979C14.5479 17.9979 14.9979 18.4479 14.9979 18.9979C14.9979 19.5479 14.5479 19.9979 13.9979 19.9979H10.3079C5.00787 19.9979 0.387871 16.0079 0.0278709 10.7179ZM6.99786 9.99786C6.99786 11.6579 8.33786 12.9979 9.99786 12.9979C11.6579 12.9979 12.9979 11.6579 12.9979 9.99786C12.9979 8.33786 11.6579 6.99786 9.99786 6.99786C8.33786 6.99786 6.99786 8.33786 6.99786 9.99786Z",
  fill: "black",
  fillOpacity: 0.54
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email-icon.d166e6b6.svg";
export { ForwardRef as ReactComponent };